export const CONTACTS_FETCH_VIEW = 'CONTACTS_FETCH_VIEW';
export const CHECK_IF_CONTACT_EXISTS = 'CHECK_IF_CONTACT_EXISTS';
export const CONTACTS_CREATE_CONTACT = 'CONTACTS_CREATE_CONTACT';
export const CONTACTS_CREATE_ROLE = 'CONTACTS_CREATE_ROLE';
export const CONTACTS_UPDATE_ROLE = 'CONTACTS_UPDATE_ROLE';
export const CONTACTS_UPDATE_CONTACT = 'CONTACTS_UPDATE_CONTACT';
export const CONTACTS_CREATE_USER = 'CONTACTS_CREATE_USER';

export enum ContactsActions {
    DELETE_CONTACT = 'DELETE_CONTACT',
    CONTACTS_FETCH_VIEW = 'CONTACTS_FETCH_VIEW',
    CONTACTS_CREATE_CONTACT = 'CONTACTS_CREATE_CONTACT',
    CONTACTS_CREATE_ROLE = 'CONTACTS_CREATE_ROLE',
    CONTACTS_UPDATE_ROLE = 'CONTACTS_UPDATE_ROLE',
    CONTACTS_UPDATE_CONTACT = 'CONTACTS_UPDATE_CONTACT',
    CONTACTS_CREATE_USER = 'CONTACTS_CREATE_USER',
    FETCH_DIRECTORY = 'FETCH_DIRECTORY',
    SELECT_CONTACT_IN_DIRECTORY = 'SELECT_CONTACT_IN_DIRECTORY',
    FETCH_USER_DATA_OF_CONTACT = 'FETCH_USER_DATA_OF_CONTACT',
}
